/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import DateFnsUtils from '@date-io/date-fns';
import TextField from '@material-ui/core/TextField';
import { useHistory } from 'react-router-dom';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import { RadioGroupComponent } from '../../../../Display/Claim/component/SelectClaim/SelectClaimSearchComponent';
import { NDCDetailsTextFieldComponent } from '../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import { PLAN_TYPE_COMMERCIAL_DATA } from '../../OnlineFixes/CreateStubInvoice/utils/constant';
import { getRebateProgramCode } from '../../OnlineFixes/CreateStubInvoice/store/action';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import * as errorConstantData from '../../../../../SharedModules/Errors/constantMessageData.js';
import {
  REBATE_PROGRAM_REQUIRED,
  FUTURE_QUARTER_ERROR,
  QUARTER_FORMAT_ERROR,
  START_QUATER_REQ,
} from '../../../../../SharedModules/Errors/constantMessageData';
import {
  setBegingQtr,
  setEndQtr,
  setRebateCD,
  setGridData,
  setPlanTypeCD,
  getMaxQuarterForFreezeDt,
} from '../store/action';
import {
  formatQuater,
  validateQuarter,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { getMaxQuarterForRebatePrg } from '../../OnlineFixes/ReqInitCorrectCmsReport/Store/actions';

const QuarterlyMarketingDataHeaders = ({ setErrorMessages, setLoading }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [planType, setPlanType] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [selectType, setSelectType] = useState('cumulative');
  const [rebateProgram, setRebateProgram] = useState();
  const [endDate, setEndDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [errors, setErrors] = useState({});
  const endQtr = useSelector(
    (state) => state?.sharedState?.QuarterlyMarketingDataReducer?.endQtr
  );
  const beginQtr = useSelector(
    (state) => state?.sharedState?.QuarterlyMarketingDataReducer?.beginQtr
  );

  const rebateCD = useSelector(
    (state) => state?.sharedState?.QuarterlyMarketingDataReducer?.rebateCD
  );
  const planTypeCD = useSelector(
    (state) => state?.sharedState?.QuarterlyMarketingDataReducer?.planType
  );
  const quarter = useSelector(
    (state) =>
      state.sharedState.CreateCmsReportReducer?.createCms64Data?.quarter
  );
  const maxFrozenQtr = useSelector(
    (state) => state.sharedState.QuarterlyMarketingDataReducer?.maxFrozenQtr
  );
  useEffect(() => {
    dispatch(getMaxQuarterForFreezeDt());
  }, []);
  useEffect(() => {
    if (maxFrozenQtr) setStartDate(maxFrozenQtr);
  }, [maxFrozenQtr]);
  useEffect(() => {
    dispatch(
      getMaxQuarterForRebatePrg({
        rebateProgramCd: rebateCD,
      })
    );
  }, [rebateCD]);
  const checkQuaterIsValid = (quater) => {
    if (quater?.includes('Q')) {
      const splitYear = quater.split('Q');
      const checkQuater = splitYear[0] <= 4;
      if (
        checkQuater &&
        splitYear.length === 2 &&
        splitYear[0].length === 1 &&
        (splitYear[1].length === 2 || splitYear[1].length === 4)
      ) {
        return true;
      }
      return false;
    }
    return false;
  };
  const checkTargetQtrIsFuture = (quater, calcQtr) => {
    const targetQtr = quater;
    if (calcQtr) {
      if (targetQtr?.split('Q')[1] > calcQtr.split('Q')[1]) {
        return true;
      }
      if (
        targetQtr.split('Q')[1] === calcQtr.split('Q')[1] &&
        targetQtr.split('Q')[0] > calcQtr.split('Q')[0]
      ) {
        return true;
      }
      return false;
    }
    return false;
  };

  const validFilter = () => {
    const localErrorMessage = [];
    const localErrors = {};

    if (!rebateProgram || rebateProgram === -1) {
      localErrorMessage.push(REBATE_PROGRAM_REQUIRED);
      localErrors.rpc = true;
    }

    if (!startDate) {
      const msg = `${START_QUATER_REQ} for generating Cumulative Report.`;
      localErrorMessage.push(msg);
      localErrors.startQtr = true;
    } else {
      localErrors.startQtr = false;
    }

    if (!endDate) {
      setEndDate(startDate);
    } else {
      localErrors.endQtr = false;
    }
    if (startDate && !checkQuaterIsValid(startDate)) {
      localErrorMessage.push(QUARTER_FORMAT_ERROR);
    } else if (endDate && !checkQuaterIsValid(endDate)) {
      localErrorMessage.push(QUARTER_FORMAT_ERROR);
    } else if (
      endDate &&
      startDate &&
      checkTargetQtrIsFuture(startDate, endDate)
    ) {
      localErrorMessage.push(FUTURE_QUARTER_ERROR);
    }

    if (localErrorMessage.length > 0) {
      setErrorMessages(localErrorMessage);
      setErrors(localErrors);
      return false;
    }
    setErrorMessages([]);
    setErrors({});
    return true;
  };
  const navigateToPage = (pathName, value) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: pathName,
    });
  };

  const rebateDropdownData = useSelector(
    (state) => state?.sharedState?.createStubInvoice?.rebateDropdownData
  );
  const defaultPlanType = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.planTypeCd
  );
  const defaultRebateCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );

  const getRebateProgramCodeValue = (value) =>
    dispatch(getRebateProgramCode(value));
  const setRebateCd = (rebateCode) => dispatch(setRebateCD(rebateCode));
  useEffect(() => {
    if (planTypeCD) {
      getRebateProgramCodeValue(planTypeCD);
      setPlanType(planTypeCD);
      if (planType === defaultPlanType) {
        setRebateCd(defaultRebateCd);
      } else {
        setRebateCd(rebateCD);
      }
    } else {
      getRebateProgramCodeValue(defaultPlanType);
      setRebateCd(defaultRebateCd);
      setPlanType(defaultPlanType);
    }
  }, [planType, defaultPlanType, defaultRebateCd]);

  useEffect(() => {
    if (startDate !== beginQtr) {
      if (beginQtr) {
        setStartDate(beginQtr);
      }
    }
  }, [beginQtr]);

  useEffect(() => {
    if (endQtr !== '' && endQtr !== endDate) setEndDate(endQtr.toUpperCase());
  }, [endQtr]);
  useEffect(() => {
    if (planType !== planTypeCD) setPlanType(planTypeCD);
  }, [planTypeCD]);

  useEffect(() => {
    if (rebateProgram !== rebateCD) setRebateProgram(rebateCD);
  }, [rebateCD]);

  return (
    <>
      <div className="row">
        <div className="col-5">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">Plan Type</legend>
            <div
              className="mt-4 row pl-10 "
              style={{ paddingLeft: '15px !important' }}
            >
              <div className="mui-custom-form col-12 m-0">
                <RadioGroupComponent
                  data={PLAN_TYPE_COMMERCIAL_DATA}
                  value={planType}
                  onChange={(_, value) => {
                    dispatch(setPlanTypeCD(value));
                    setPlanType(value);
                    setRebateProgram(-1);
                  }}
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-3">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">Quarter</legend>
            <div
              className="row pl-10"
              style={{ paddingLeft: '15px !important' }}
            >
              <div style={{ width: '48%' }}>
                <div className="dif no-margin">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="from"
                      label="From"
                      fullWidth
                      placeholder=""
                      inputProps={{ maxlength: 6, id: 'from' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                      value={startDate}
                      onChange={(e) => {
                        dispatch(setBegingQtr(e?.target?.value));
                        setStartDate(e?.target?.value);
                        // validFilter();
                      }}
                      onBlur={(e) => {
                        let value = e.target?.value;
                        if (value && validateQuarter(value)) {
                          value = formatQuater(value);
                        }
                        setStartDate(value);
                        if (endDate == null || endDate === '') {
                          setEndDate(value);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ width: '48%' }}>
                <div className="dif no-margin">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <div className="mui-custom-form with-select input-md">
                      <TextField
                        id="to"
                        label="To"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxlength: 6, id: 'to' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                        value={endDate}
                        onChange={(e) => {
                          dispatch(setEndQtr(e?.target?.value));
                          setEndDate(e?.target?.value);
                        }}
                        onBlur={(e) => {
                          let value = e?.target?.value;
                          if (value && validateQuarter(value)) {
                            value = formatQuater(value);
                          }
                          setEndDate(value);
                        }}
                      />
                    </div>
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-4">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">Rebate Program</legend>
            <NDCDetailsTextFieldComponent
              label=""
              required
              value={rebateProgram}
              error={(errors && errors.rpc) || false}
              className="ml-0 with-select"
              select
              selectReset
              selectData={rebateDropdownData}
              disabled={false}
              onChange={(e) => {
                setRebateCd(e.target.value);
                setRebateProgram(e.target.value);
              }}
            />
          </fieldset>
        </div>
        <div
          className={`${
            selectType === 'single' ? 'col-8' : 'col-10'
          } mt-4 my-3 d-flex align-items-center justify-content-end`}
        >
          <Button
            className="btn-success same-font-family d-flex align-items-center"
            onClick={async () => {
              const validateFilter = validFilter();
              const toQtrVal =
                endDate == null || endDate === '' ? startDate : endDate;
              dispatch(setBegingQtr(startDate.toUpperCase()));
              dispatch(setEndQtr(toQtrVal.toUpperCase()));
              if (validateFilter) {
                setLoading(true);
                const payload = {
                  rebateProgramCode: rebateProgram,
                  fromQtr: startDate,
                  toQtr: toQtrVal,
                };
                const response = await axios.post(
                  `${serviceEndPoint.QUARTERLY_MARKETING_DATA}`,
                  payload
                );
                setLoading(false);

                if (response?.data?.name == 'Error') {
                  setErrorMessages([errorConstantData.FAIL_PROCESSING_REQUEST]);
                  dispatch(setGridData([]));
                } else if (response?.data === 'No records are retrieved.') {
                  setErrorMessages(['No Records Found']);
                  dispatch(setGridData([]));
                } else {
                  dispatch(setGridData(response?.data));
                  navigateToPage(
                    'quarterlyMarketingDataTableDetails',
                    'Display Quartely Marketing Data'
                  );
                }
              }
            }}
          >
            <SVGComponent iconName="Create-new-icon" />
            Process
          </Button>
        </div>
      </div>
    </>
  );
};
export default QuarterlyMarketingDataHeaders;
